export default "__VITE_ASSET__DHZDG2VD__"